// @flow
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import { get, find } from "lodash";
import type { SetRaceAlertsActionType } from "@tvg/shared-actions/UserActions";
import type { ChannelUFC } from "@tvg/types/Alerts";
import mediator from "@tvg/mediator";
import ufc from "@tvg/api/ufc";
import { getAccountNumber } from "@urp/store-selectors";
import RaceAlerts from "@tvg/atomic-ui/_templates/RaceAlerts";
import { setRaceAlerts } from "@tvg/shared-actions/UserActions";

type Props = {
  isNotificationsEnabled: boolean,
  raceAlerts: ChannelUFC[],
  showTopBorder: boolean,
  showBottomBorder: boolean,
  racePostTime: string,
  raceTrackCode: string,
  raceNumber: string,
  tvgRaceId: string,
  showRaceNumber: boolean,
  module: string,
  accountNumber: string,
  dispatch: Dispatch<SetRaceAlertsActionType>,
  isRaceAlertsAvailable: boolean
};

export const getRaceAlert = (
  channels: ChannelUFC[],
  raceId: string
): ?ChannelUFC => channels.find((channel) => channel.entityName === raceId);

export class RaceAlertsComponent extends PureComponent<Props> {
  static defaultProps = {
    showTopBorder: false,
    showBottomBorder: false,
    racePostTime: "",
    raceTrackCode: "",
    raceNumber: "",
    tvgRaceId: "",
    snowRaceNumber: false,
    module: "",
    accountNumber: "",
    isNotificationsEnabled: true,
    raceAlerts: [],
    isRaceAlertsAvailable: true
  };

  onEnableRaceAlerts = () => {
    if (this.props.isNotificationsEnabled) {
      // request to ufc: add this race to alerts
      ufc
        .setUserAlerts(
          this.props.accountNumber,
          [this.props.tvgRaceId],
          "race",
          ["raceResults", "timeToRace"]
        )
        .then((results) => {
          const updatedRaceAlerts = this.props.raceAlerts.concat(
            get(results, "data[0]")
          );
          this.props.dispatch(setRaceAlerts(updatedRaceAlerts));
        });
    } else {
      mediator.ios.dispatch({ type: "ASK_PUSH_NOTIFICATION_STATE" });
    }
    // gtm event
    mediator.base.dispatch({
      type: "RACE_ALERTS:TOGGLE",
      payload: {
        toggledOn: true,
        module: this.props.module,
        eventLabel: "Alerts For Race"
      }
    });
  };

  onDisableRaceAlerts = () => {
    const updatedChannels = this.props.raceAlerts.filter(
      (channel) => channel.entityName !== this.props.tvgRaceId.toString()
    );

    const alert = getRaceAlert(
      this.props.raceAlerts,
      this.props.tvgRaceId.toString()
    );

    ufc.deleteUserAlert(this.props.accountNumber, [get(alert, "favoriteId")]);
    this.props.dispatch(setRaceAlerts(updatedChannels));
    // gtm event
    mediator.base.dispatch({
      type: "RACE_ALERTS:TOGGLE",
      payload: {
        toggledOn: false,
        module: this.props.module,
        eventLabel: "Alerts For Race"
      }
    });
  };

  isRaceAlertsEnabled = () =>
    !!find(
      this.props.raceAlerts,
      (c) => c.entityName === this.props.tvgRaceId.toString()
    );

  render() {
    const isRaceAlertsEnabled = this.isRaceAlertsEnabled();
    return (
      this.props.isRaceAlertsAvailable && (
        <RaceAlerts
          raceNumber={
            this.props.showRaceNumber ? this.props.raceNumber : undefined
          }
          showTopBorder={this.props.showTopBorder}
          showBottomBorder={this.props.showBottomBorder}
          onToggleClick={
            isRaceAlertsEnabled
              ? this.onDisableRaceAlerts
              : this.onEnableRaceAlerts
          }
          isOn={isRaceAlertsEnabled}
        />
      )
    );
  }
}

const mapStateToProps = (store) => ({
  isRaceAlertsAvailable: get(store, "capi.featureToggles.raceAlertsUFC", false),
  isNotificationsEnabled: get(store, "ios.isNotificationsEnabled"),
  raceAlerts: get(store, "alerts.raceAlerts", []),
  accountNumber: getAccountNumber(store)
});

// $FlowFixMe
export default connect(mapStateToProps)(RaceAlertsComponent);
